export enum DealStatus {
  notReviewed = 'not_reviewed',
  approved = 'approved',
  skipped = 'skipped',
}

export enum DealRelation {
  acquired = 'ACQUIRED_RIGHTS_FOR',
  deal = 'DEAL_WITH',
}

export enum DealType {
  deal = 'deal',
  acquisition = 'acquisition',
}

export enum EntityType {
  company = 'COMPANY',
  content = 'CONTENT',
  person = 'PERSON',
}

export enum DealSourceType {
  manual = 'manual',
  ml = 'ml',
  deli = 'deli',
}

export enum DealBadge {
  acquisition = 'acquisition',
  distribution = 'distribution',
  production = 'production',
  talent_representation= 'Talent Representation',
  channel_app='Channel/App Distribution',
  ma_jvs='M&A/JVs',
  merchandising='Merchandising',
  podcast_gaming='Podcasts & Gaming'
}
